import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f0b7890"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-20" }
const _hoisted_2 = { class: "md:border-b w-full py-15 lowercase md:flex md:justify-between md:items-center" }
const _hoisted_3 = {
  key: 0,
  class: "border-b pb-10 mb-20 md:py-8 md:mb-0 md:border-0"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full md:ml-auto md:w-auto md:flex md:flex-col md:justify-between md:h-full" }, null, -1))
const _hoisted_5 = {
  key: "hasNoWishListItems",
  class: "mt-40"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WishListShareButton = _resolveComponent("WishListShareButton")!
  const _component_NativeShareButton = _resolveComponent("NativeShareButton")!
  const _component_WishListItem = _resolveComponent("WishListItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.details.name), 1),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_NativeShareButton, {
        "share-button-text": _ctx.labels.shareListBtn,
        "share-url": _ctx.shareUrl,
        "link-title": _ctx.details.name
      }, {
        default: _withCtx(() => [
          _createVNode(_component_WishListShareButton, {
            "share-url": _ctx.shareUrl,
            "share-image": _ctx.listDefaultImageUrl
          }, null, 8, ["share-url", "share-image"])
        ]),
        _: 1
      }, 8, ["share-button-text", "share-url", "link-title"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.details.wishListItems?.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.details.wishListItems?.length) + " " + _toDisplayString(_ctx.labels.items), 1))
        : _createCommentVNode("", true),
      _hoisted_4
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details.wishListItems, (item) => {
      return (_openBlock(), _createBlock(_component_WishListItem, {
        key: item.id,
        item: item,
        "is-public": true,
        readonly: true
      }, null, 8, ["item"]))
    }), 128)),
    (!_ctx.hasWishListItems)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_ctx.labels.emptyList), 1))
      : _createCommentVNode("", true)
  ], 64))
}